import useTopicsMenuName from './useTopicsMenuName';

const useMyTopicsName = () => {
  const menuName = useTopicsMenuName();

  return s__('Topics|My %{menuName}').i__({
    menuName,
  });
};

export default useMyTopicsName;
